<template>
  <div class="msg-wrapper" v-if="content" >
    <p
      class="msg-desc"
      v-text="content"
    ></p>
  </div>
</template>

<script>
export default {
  name: 'WeakTips',
  props: {
    content: String,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped >
.msg-desc {
  padding: 12px 14px;
  line-height: 16px;
  font-size: 12px;
  font-family: 'Aspira Medium';
  font-weight: 200;
  color: #1BB17C;
  background: #EFFAF5;
  border-radius: 4px;
  overflow: hidden;
}
@media screen and (max-width: 768px){
  .msg-desc {
    margin-top: rem(30);
    padding: rem(24) rem(32);
    line-height: rem(32);
    font-size: rem(24);
    border-radius: rem(8);
  }
}
</style>